export default __webpack_public_path__ + "static/qa-performance-5b78acec24378fd6fe5af0b7b243daf1.png";